import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button", "icon"]

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")

    // Update aria-expanded
    const isExpanded = !this.menuTarget.classList.contains("hidden")
    this.buttonTarget.setAttribute("aria-expanded", isExpanded)
  }

  select(event) {
    event.stopPropagation()
    const theme = event.currentTarget.dataset.themeName
    this.currentTheme = theme
    this.applyTheme(theme)
    this.updateIcon(theme)
    this.menuTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")

    localStorage.setItem("theme", theme)
  }

  applyTheme(theme) {
    const html = document.documentElement

    html.removeAttribute("data-theme")

    if (theme === "default") {
      // Use system preference
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      if (prefersDark) {
        html.setAttribute("data-theme", "dark")
      } else {
        html.setAttribute("data-theme", "light")
      }
    } else {
      html.classList.add(theme)
      html.setAttribute("data-theme", theme)
    }
  }

  updateIcon(theme) {
    if (!this.hasIconTarget) return

    // Determine the effective theme (for "default", use system preference)
    let effectiveTheme = theme
    if (theme === "default") {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      effectiveTheme = prefersDark ? "dark" : "light"
    }

    // Sun icon for light theme
    const sunIcon = `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>`

    // Moon icon for dark theme
    const moonIcon = `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>`

    // Update the icon based on effective theme
    if (effectiveTheme === "light") {
      this.iconTarget.innerHTML = sunIcon
    } else {
      this.iconTarget.innerHTML = moonIcon
    }
  }

  // Close menu when clicking outside
  clickOutside(event) {
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.add("hidden")
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
  }
}
